import Lottie from "lottie-react";
// redux
import { useSelector } from "react-redux";

interface DotLottieProps {
  animation: {};
  widthWideScreen?: number;
  heightWideScreen?: number;
  widthSmallScreen?: number;
  heightSmallScreen?: number;
  loop?: boolean;
  topSmall?: string;
  handleComplete?: () => void;
}
const DotLottie = ({
  animation,
  loop = true,
  widthWideScreen = 400,
  heightWideScreen = 400,
  widthSmallScreen = 250,
  heightSmallScreen = 250,
  topSmall = "10rem",
  handleComplete,
}: DotLottieProps) => {
  const mobileMode = useSelector((state: any) => state.app.mobileMode);

  return (
    <>
      <Lottie
        animationData={animation}
        loop={loop}
        onComplete={handleComplete}
        autoplay={true}
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        style={{
          width: !mobileMode ? widthWideScreen : widthSmallScreen,
          height: !mobileMode ? heightWideScreen : heightSmallScreen,
          position: !mobileMode ? "static" : "absolute",
          top: !mobileMode ? 0 : topSmall,
        }}
      />
    </>
  );
};

export default DotLottie;
